import gql from 'graphql-tag';

import client from '../graphqlAPI';

const POST_DELETE_TICKET_MUTATION = gql`
  mutation Post(
    $id: String!,
    $ticketSlugName: String!,
    ) {
    postDeleteTicket(
      id: $id,
      ticketSlugName: $ticketSlugName,
      ) {
      isAuth
      isDeleted
      ticketSlugName
      isUsed { eventSlugNames }
    }
  }
`;

const postDeleteTicket = async ({
  id,
  ticketSlugName,
}) => {
  try {
    const result = await client.mutate({
      mutation: POST_DELETE_TICKET_MUTATION,
      variables: {
        id,
        ticketSlugName,
      },
      fetchPolicy: 'no-cache',
    })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const { data: { postDeleteTicket: postDeleteTicketValidationData } } = result;

    if (postDeleteTicketValidationData) {
      return postDeleteTicketValidationData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: postDeleteTicketValidationData = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: postDeleteTicket Error: ${error}`);
    return null;
  }
};

export default postDeleteTicket;
